export enum AlertSkins {
  INFO,
  WARNING,
  ERROR
}
